import { render, staticRenderFns } from "./IMTeamAnnouncement.vue?vue&type=template&id=600dc6ac&scoped=true&"
import script from "@/scripts/IMTeamAnnouncement/index.js?vue&type=script&lang=js&"
export * from "@/scripts/IMTeamAnnouncement/index.js?vue&type=script&lang=js&"
import style0 from "./IMTeamAnnouncement.vue?vue&type=style&index=0&id=600dc6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600dc6ac",
  null
  
)

export default component.exports